if( $('.ac-free-shipping').length )  {
  $("#FreeShipping").slick({
          infinite: true,
          centermode: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          fade: true,
          centerMode: true,
          centerPadding: '0',
          autoplay: true,
          autoplaySpeed: 4000,
          cssEase: 'linear',
        });
}

if( $('#product-announcements').length )  {
  $("#product-announcements").slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          appendDots: $('.announcement-dots'),
          fade: true,
          vertical: false,
          verticalSwiping: true,
          centerMode: true,
          centerPadding: '0',
          autoplay: true,
          autoplaySpeed: 10000,
          cssEase: 'linear',
        });
}